import React from 'react'

import { TitleProps } from '../interfaces'
import { HeaderModal } from '../styled'

export function Header ({ title }: TitleProps) {
  return <HeaderModal>{title}</HeaderModal>
}
